import { gsap } from 'gsap'

const words = document.querySelectorAll('.inpHomehero__rotating-words--rotating-word');
if (words.length > 0) {
  let index = 0;

  function rotateWords() {
    const current = words[index];
    const nextIndex = (index + 1) % words.length;
    const next = words[nextIndex];

    gsap.to(current, {
      scale: 0.7, 
      y: -120,
      duration: 0.8,
      ease: "power1.inOut",
      onComplete: () => {
        gsap.set(current, {scale: 0, y: 0});
      }
    });

    gsap.fromTo(next,
      {scale: 0, y: 90}, 
      {scale: 1, y: 0, duration: 0.8, ease: "power1.inOut"}
    );

    index = nextIndex;
  }

  gsap.set(words, {scale: 0, y: 0});
  gsap.set(words[0], {scale: 1, y: 0});

  setInterval(rotateWords, 2000);
}